import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Axios Case Study | Canny';
const Description =
  'Read about how Axios uses Canny to keep internal teams aligned, inform stakeholders, and reduce time spent on messy communications.';
const Image = 'https://canny.io/images/canny-social.png';
const AxiosUrl = 'https://canny.io/case-studies/axios';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${AxiosUrl}#webpage`,
    url: AxiosUrl,
    name: 'Case Study: Axios × Canny',
    description:
      'How Axios uses Canny to keep internal teams aligned, inform stakeholders, and reduce time spent on messy communication.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${AxiosUrl}#article`,
    genre: 'Case Study',
    headline:
      'How Axios uses Canny to keep internal teams aligned, inform stakeholders, and reduce time spent on messy communication',
    description:
      'Axios used Canny as a single source of truth for feedback. During their beta launch, engagement surged immediately. Post-launch, product managers use the feedback board to prioritize effectively, quickly communicate updates, and re-engage inactive users—saving time and improving user trust.',
    inLanguage: 'en',
    url: AxiosUrl,
    mainEntityOfPage: { '@id': `${AxiosUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Axios', url: 'https://www.axios.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Axios', item: AxiosUrl },
  ]),
]);

export default class AxiosLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: AxiosUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
